import {
  copyIcon,
  SVGIcon,
} from "@progress/kendo-svg-icons"; 
export interface MenuItems {
  text?: string;
  children?: MenuItems[];
  separator?: boolean;
  svgIcon?: SVGIcon;
  childText?: string;
}
 
export const menuItems: MenuItems[] = [
  {
    text: "Copy",
    svgIcon: copyIcon,
  },
  {
    text: "Copy with Headers",
    svgIcon: copyIcon,
  },
  { separator: true },

  {
    text: "Export",
    // svgIcon: "copy",
    children: [
      { childText: "CSV Export" },
      // { childText: "Excel Export" },
      { childText: "Excel Export (w/o styles)" },
    ],
  },
  
  
];
 